import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** POST `/srm/purchase-order/{id}/close`。body 僅 `updatedAt`。 */
export async function closePurchaseOrder(id, payload = {}) {
  const { data: raw } = await request.post(
    `/srm/purchase-order/${id}/close`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
